import React from "react";

import _ from "lodash";

import useForm from "commons/hooks/useForm";

import { FormHookType } from "commons/types/form";
import { ObjectPropertyType } from "commons/types/validation";

import { useBlockGroupContext } from "components/form/Blocks";

import { useSaveActionsContext } from "context/save";

import useSectionFiveImagesFifteenTextsApi from "hooks/api/private/blocks/useSectionFiveImagesFifteenTextsApi";
import { ButtonDeleteInterface } from "hooks/useTitleFunctionsTopBlock";

import {
    SectionFiveImagesFifteenTextsBody,
    SectionFiveImagesFifteenTextsDetails,
} from "types/api/blocks/sectionFiveImagesFifteenTexts";
import { LanguageEnum } from "types/api/commons";

import { getExtraErrorsDescription } from "utils/validators";

export type SectionSevenTextsForm = {
    id: string | undefined;
    text: {
        [x in LanguageEnum]: {
            text_1: string;
            text_2: string;
            text_3: string;
            text_4: string;
            text_5: string;
            text_6: string;
            text_7: string;
        };
    };
};

type SectionSevenTextsType = {
    buttonDelete: ButtonDeleteInterface;
    formHook: FormHookType<SectionSevenTextsForm>;
};

function useSectionSevenTexts(): SectionSevenTextsType {
    const { blockGroupCompositionId } = useBlockGroupContext();

    const {
        saveSectionFiveImagesFifteenTexts,
        getOneSectionFiveImagesFifteenTexts,
        deleteSectionFiveImagesFifteenTexts,
    } = useSectionFiveImagesFifteenTextsApi();

    const schema = React.useMemo<ObjectPropertyType>(
        () => ({
            type: "object",
            properties: {
                id: {
                    type: "simple",
                    validators: [],
                },
                text: {
                    type: "collection",
                    of: {
                        type: "object",
                        properties: {
                            text_1: {
                                type: "simple",
                                validators: [],
                            },
                            text_2: {
                                type: "simple",
                                validators: [],
                            },
                            text_3: {
                                type: "simple",
                                validators: [],
                            },
                            text_4: {
                                type: "simple",
                                validators: [],
                            },
                            text_5: {
                                type: "simple",
                                validators: [],
                            },
                            text_6: {
                                type: "simple",
                                validators: [],
                            },
                            text_7: {
                                type: "simple",
                                validators: [],
                            },
                        },
                    },
                },
            },
        }),
        [],
    );

    const initialValues: SectionSevenTextsForm = React.useMemo(() => {
        return {
            id: undefined,
            text: {
                it: {
                    text_1: "",
                    text_2: "",
                    text_3: "",
                    text_4: "",
                    text_5: "",
                    text_6: "",
                    text_7: "",
                },
                en: {
                    text_1: "",
                    text_2: "",
                    text_3: "",
                    text_4: "",
                    text_5: "",
                    text_6: "",
                    text_7: "",
                },
            },
        };
    }, []);

    const formHook = useForm<SectionSevenTextsForm>(
        schema,
        initialValues,
        getExtraErrorsDescription,
    );

    const { showAllError, setForm, isValid, form } = formHook;

    React.useEffect(() => {
        console.log("useSectionSevenTexts 1");
        console.log(form);

        console.log("useSectionSevenTexts 2");
        console.log(isValid);
    }, [form, isValid]);

    const [sectionFiveImagesFifteenTextsDetails, setSectionFiveImagesFifteenTextsDetails] =
        React.useState<SectionFiveImagesFifteenTextsDetails | undefined>(undefined);

    React.useEffect(() => {
        const [apiCall, abortController] = getOneSectionFiveImagesFifteenTexts(
            { id: blockGroupCompositionId },
            { rejectNotFound: true },
        );

        apiCall.then(setSectionFiveImagesFifteenTextsDetails).catch((error) => console.log(error));

        return () => abortController.abort();
    }, [
        setSectionFiveImagesFifteenTextsDetails,
        getOneSectionFiveImagesFifteenTexts,
        blockGroupCompositionId,
    ]);

    React.useEffect(() => {
        if (sectionFiveImagesFifteenTextsDetails) {
            setForm((prevForm) => {
                const newForm = _.cloneDeep(prevForm);

                newForm.id = sectionFiveImagesFifteenTextsDetails.id;

                newForm.text.en.text_1 = sectionFiveImagesFifteenTextsDetails.text.en.text_1;
                newForm.text.en.text_2 = sectionFiveImagesFifteenTextsDetails.text.en.text_2;
                newForm.text.en.text_3 = sectionFiveImagesFifteenTextsDetails.text.en.text_3;
                newForm.text.en.text_4 = sectionFiveImagesFifteenTextsDetails.text.en.text_4;
                newForm.text.en.text_5 = sectionFiveImagesFifteenTextsDetails.text.en.text_5;
                newForm.text.en.text_6 = sectionFiveImagesFifteenTextsDetails.text.en.text_6;
                newForm.text.en.text_7 = sectionFiveImagesFifteenTextsDetails.text.en.text_7;

                newForm.text.it.text_1 = sectionFiveImagesFifteenTextsDetails.text.it.text_1;
                newForm.text.it.text_2 = sectionFiveImagesFifteenTextsDetails.text.it.text_2;
                newForm.text.it.text_3 = sectionFiveImagesFifteenTextsDetails.text.it.text_3;
                newForm.text.it.text_4 = sectionFiveImagesFifteenTextsDetails.text.it.text_4;
                newForm.text.it.text_5 = sectionFiveImagesFifteenTextsDetails.text.it.text_5;
                newForm.text.it.text_6 = sectionFiveImagesFifteenTextsDetails.text.it.text_6;
                newForm.text.it.text_7 = sectionFiveImagesFifteenTextsDetails.text.it.text_7;

                return newForm;
            });
        }
    }, [setForm, sectionFiveImagesFifteenTextsDetails]);

    const { addSaveAction } = useSaveActionsContext();

    React.useEffect(() => {
        addSaveAction(blockGroupCompositionId, () => {
            if (isValid) {
                const sectionFiveImagesFifteenTextsBody: SectionFiveImagesFifteenTextsBody = {
                    id: blockGroupCompositionId,
                    img_one: {
                        id: undefined,
                        desktop: undefined,
                        mobile: undefined,
                    },
                    img_two: {
                        id: undefined,
                        desktop: undefined,
                        mobile: undefined,
                    },
                    img_three: {
                        id: undefined,
                        desktop: undefined,
                        mobile: undefined,
                    },
                    img_four: {
                        id: undefined,
                        desktop: undefined,
                        mobile: undefined,
                    },
                    img_five: {
                        id: undefined,
                        desktop: undefined,
                        mobile: undefined,
                    },
                    text: {
                        it: {
                            text_1: form.text.it.text_1,
                            text_2: form.text.it.text_2,
                            text_3: form.text.it.text_3,
                            text_4: form.text.it.text_4,
                            text_5: form.text.it.text_5,
                            text_6: form.text.it.text_6,
                            text_7: form.text.it.text_7,
                            text_8: "",
                            text_9: "",
                            text_10: "",
                            text_11: "",
                            text_12: "",
                            text_13: "",
                            text_14: "",
                            text_15: "",
                        },
                        en: {
                            text_1: form.text.en.text_1,
                            text_2: form.text.en.text_2,
                            text_3: form.text.en.text_3,
                            text_4: form.text.en.text_4,
                            text_5: form.text.en.text_5,
                            text_6: form.text.en.text_6,
                            text_7: form.text.en.text_7,
                            text_8: "",
                            text_9: "",
                            text_10: "",
                            text_11: "",
                            text_12: "",
                            text_13: "",
                            text_14: "",
                            text_15: "",
                        },
                    },
                };

                const [apiCall] = saveSectionFiveImagesFifteenTexts(
                    sectionFiveImagesFifteenTextsBody,
                );

                const promises: Promise<unknown>[] = [];

                promises.push(apiCall);

                return Promise.all(promises);
            } else {
                showAllError();
                return Promise.reject("INVALID_FORM");
            }
        });
    }, [
        addSaveAction,
        blockGroupCompositionId,
        form,
        isValid,
        saveSectionFiveImagesFifteenTexts,
        showAllError,
    ]);

    return React.useMemo(
        (): SectionSevenTextsType => ({
            buttonDelete: deleteSectionFiveImagesFifteenTexts,
            formHook,
        }),
        [deleteSectionFiveImagesFifteenTexts, formHook],
    );
}

export default useSectionSevenTexts;
